(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("promote-analytics-adapter", [], factory);
	else if(typeof exports === 'object')
		exports["promote-analytics-adapter"] = factory();
	else
		root["promote-analytics-adapter"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paramsMapper = exports.paramsMapper = function paramsMapper(params, mapper) {
  var mappedParams = Object.keys(params);
  if (mappedParams.length === 0) {
    return params;
  }
  return mappedParams.reduce(function (mappedObject, currentKey) {
    var newKey = mapper[currentKey];
    if (newKey && (params[currentKey] || params[currentKey] === 0)) {
      mappedObject[newKey] = params[currentKey];
    }
    return mappedObject;
  }, {});
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.mapParam = mapParam;
exports.encodeValue = encodeValue;
exports.encodePrice = encodePrice;
exports.removeSpaces = removeSpaces;
function mapParam(mapper, name, value) {
  return typeof mapper[name] === 'function' ? mapper[name](value) : { name: name, value: value };
}

function encodeValue() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    if (value instanceof Number || value instanceof Boolean || value instanceof String) {
      value = value.valueOf();
    } else if (value !== null) {
      value = JSON.stringify(value);
    }
  }

  return value;
}

function encodePrice(price) {
  if (typeof price === 'number') {
    return Math.round(price * 10000);
  }

  return price;
}

function removeSpaces(str) {
  return str && ('' + str).replace(/\s/g, '');
}

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = exports.init = undefined;

var _Adapter = __webpack_require__(8);

var adapter = new _Adapter.Adapter();

var init = exports.init = function init() {
  var channels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  channels.forEach(adapter.addChannel);
};

var trackEvent = exports.trackEvent = function trackEvent(eventName, params, options) {
  adapter.trackEvent(eventName, params, options);
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channels = exports.channelNames = undefined;

var _channels;

var _facebookPixel = __webpack_require__(11);

var _googleAnalytics = __webpack_require__(12);

var _googleTagManager = __webpack_require__(13);

var _wixAnalytics = __webpack_require__(14);

var _biAnalytics = __webpack_require__(15);

var _gtag = __webpack_require__(16);

var _vkRetargeting = __webpack_require__(17);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var channelNames = exports.channelNames = {
  FACEBOOK_PIXEL: 'facebookPixel',
  GOOGLE_ANALYTICS: 'googleAnalytics',
  GOOGLE_TAG_MANAGER: 'googleTagManager',
  WIX_ANALYTICS: 'wixAnalytics',
  BI_ANALYTICS: 'biAnalytics',
  GTAG: 'gtag',
  VK_RETARGETING: 'vkRetargeting'
};

var channels = exports.channels = (_channels = {}, _defineProperty(_channels, channelNames.FACEBOOK_PIXEL, _facebookPixel.channelEvents), _defineProperty(_channels, channelNames.GOOGLE_ANALYTICS, _googleAnalytics.channelEvents), _defineProperty(_channels, channelNames.GOOGLE_TAG_MANAGER, _googleTagManager.channelEvents), _defineProperty(_channels, channelNames.WIX_ANALYTICS, _wixAnalytics.channelEvents), _defineProperty(_channels, channelNames.BI_ANALYTICS, _biAnalytics.channelEvents), _defineProperty(_channels, channelNames.GTAG, _gtag.channelEvents), _defineProperty(_channels, channelNames.VK_RETARGETING, _vkRetargeting.channelEvents), _channels);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adapter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventsDispatcher = __webpack_require__(9);

var _channels = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Adapter = exports.Adapter = function () {
  function Adapter() {
    var _this = this;

    var channels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Adapter);

    this._channels = [];

    this.addChannel = function (channel) {
      if (_this.isChannelAlreadyInit(channel)) {
        return;
      }
      if (_this.isChannelPredefined(channel)) {
        _this.populateChannelEvents(channel);
      } else {
        _this.registerChannel(channel);
      }
      if (_this.isChannelValid(channel)) {
        _this._channels.push(channel);
      }
    };

    this.trackEvent = function (eventName, params, options) {
      (0, _eventsDispatcher.dispatchEvent)(_this._channels, eventName, params, options);
    };

    this.isChannelAlreadyInit = function (channel) {
      return _this._channels.some(function (_channel) {
        return _channel.name === channel.name;
      });
    };

    channels.forEach(this.addChannel);
  }

  _createClass(Adapter, [{
    key: 'isChannelPredefined',
    value: function isChannelPredefined(channel) {
      return _channels.channels[channel.name];
    }
  }, {
    key: 'populateChannelEvents',
    value: function populateChannelEvents(channel) {
      channel.events = _channels.channels[channel.name];
    }
  }, {
    key: 'isChannelValid',
    value: function isChannelValid(channel) {
      var hasName = channel.name;
      var hasReportFunction = channel.report;
      var hasEvents = channel.events && Object.values(channel.events).every(function (event) {
        return typeof event === 'function';
      });
      return hasName && hasReportFunction && hasEvents;
    }
  }, {
    key: 'registerChannel',
    value: function registerChannel(channel) {
      if (this.isChannelValid(channel)) {
        _channels.channels[channel.name] = channel.events;
      }
    }
  }]);

  return Adapter;
}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchEvent = undefined;

var _eventsMapper = __webpack_require__(10);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var dispatchEvent = exports.dispatchEvent = function dispatchEvent(channels, eventName, params, options) {

  channels.forEach(function (channel) {
    (0, _eventsMapper.getArgumentsLists)(eventName, channel, params, options).forEach(function (args) {
      return channel.report.apply(channel, _toConsumableArray(args));
    });
  });
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var events = exports.events = {};

var getArgumentsLists = function getArgumentsLists(eventName, channel) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var appDefId = params.appDefId,
      eventParams = _objectWithoutProperties(params, ["appDefId"]);

  options.config = channel.config;
  options.context = options.context || {};

  options.context.appDefId = options.context.appDefId || appDefId;

  return channel.events[eventName] ? channel.events[eventName](eventParams, options) : [];
};
exports.getArgumentsLists = getArgumentsLists;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelEvents = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _paramsMapper = __webpack_require__(3);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
* Adapter for Facebook Pixel
*/

/* eslint-disable camelcase */
var channelParams = {
  id: 'id', // ID of a product inside product catalog
  price: 'value', // Value of a user performing this event to the business
  value: 'value', // Value of a user performing this event to the business
  revenue: 'value', // Value of a user performing this event to the business
  name: 'content_name', // Name of the page/product
  category: 'content_category', // Category of the page/product
  currency: 'currency', // *fbp specific - Currency for the value specified
  content_ids: 'content_ids', // *fbp specific - Product ids associated with the event. e.g. SKUs of products for AddToCart event: ['ABC123', 'XYZ789']
  contents: 'contents', // *fbp specific - A list of JSON object that contains the product ids associated with the event as well as additional information about the products
  type: 'content_type', // *fbp specific - Either 'product' or 'product_group' based on the content_ids or contents being passed
  num_items: 'num_items', // *fbp specific, initiateCheckout event only - The number of items that checkout was initiated for
  quantity: 'quantity', // *fbp specific - The number of items that checkout was initiated for
  label: 'content_name' // *fbp specific - Mapping of lead event label, specifying lead origin (e.g. Contact Form)
};

var calculatePrice = function calculatePrice(params) {
  return (Number.parseFloat(params.tax) || 0) + (Number.parseFloat(params.shipping) || 0) + params.contents.reduce(function (totalValue, product) {
    return totalValue + Number.parseFloat(product.item_price) * product.quantity;
  }, 0);
};

var getCurrency = function getCurrency(params) {
  return params.contents && params.contents[0].currency;
};

var verifyParams = function verifyParams(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'product' : _ref$type,
      params = _objectWithoutProperties(_ref, ['type']);

  var verifiedParams = Object.assign({}, params, { type: type });
  if (verifiedParams.contents) {
    verifiedParams.contents = verifiedParams.contents.map(function (product) {
      product.quantity = product.quantity || 1;
      product.item_price = product.item_price || product.price || 0;
      return product;
    });
    if (!verifiedParams.price && !verifiedParams.value && !verifiedParams.revenue) {
      verifiedParams.price = calculatePrice(verifiedParams).toString();
    }
    if (!verifiedParams.currency) {
      verifiedParams.currency = getCurrency(verifiedParams);
    }
  }
  return (0, _paramsMapper.paramsMapper)(verifiedParams, channelParams);
};

var addNumItems = function addNumItems(params) {
  if (params.contents && !params.num_items) {
    var newParams = _extends({}, params);
    newParams.num_items = newParams.contents.reduce(function (num_items, product) {
      return num_items += product.quantity || 1;
    }, 0);
    return newParams;
  }
  return params;
};

var channelEvents = {
  ViewContent: function ViewContent(_ref2) {
    var id = _ref2.id,
        params = _objectWithoutProperties(_ref2, ['id']);

    return [['track', 'ViewContent', _extends({}, verifyParams(params), { content_ids: [id] })]];
  },
  AddToCart: function AddToCart(_ref3) {
    var id = _ref3.id,
        params = _objectWithoutProperties(_ref3, ['id']);

    return [['track', 'AddToCart', _extends({}, verifyParams(params), { content_ids: [id] })]];
  },
  InitiateCheckout: function InitiateCheckout(params) {
    return [['track', 'InitiateCheckout', _extends({}, verifyParams(addNumItems(params)), params.contents && { content_ids: params.contents.map(function (product) {
        return product.id;
      }) })]];
  },
  AddPaymentInfo: function AddPaymentInfo(params) {
    return [['track', 'AddPaymentInfo', _extends({}, verifyParams(addNumItems(params)), params.contents && { content_ids: params.contents.map(function (product) {
        return product.id;
      }) })]];
  },
  Purchase: function Purchase(params) {
    return [['track', 'Purchase', _extends({}, verifyParams(addNumItems(params)), params.contents && { content_ids: params.contents.map(function (product) {
        return product.id;
      }) })]];
  },
  Lead: function Lead(params) {
    return [['track', 'Lead', (0, _paramsMapper.paramsMapper)(params, channelParams)]];
  },
  CustomEvent: function CustomEvent(params) {
    var event = params.event,
        _params$eventAction = params.eventAction,
        eventAction = _params$eventAction === undefined ? 'customEvent' : _params$eventAction,
        rest = _objectWithoutProperties(params, ['event', 'eventAction']);

    return [['trackCustom', event || eventAction, rest]];
  }
};
exports.channelEvents = channelEvents;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelEvents = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _paramsMapper = __webpack_require__(3);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
 * Adapter for Google Analytics
 */
var channelParams = {
  price: 'price', // Value of a user performing this event to the business
  sku: 'id', // Product stock keeping unit id
  id: 'id', // *ga specific - Product ID (string)
  currency: 'currency', // The currency for the price specified
  name: 'name', // Name of the page/product
  category: 'category', // Category of the page/product
  brand: 'brand', // *ga specific - Product brand (string)
  variant: 'variant', // *ga specific - Product variant (string)
  list: 'list', // *ga specific - Name of the list the product was selected from, e.g 'search results'
  quantity: 'quantity', // *ga specific - Product quantity (number)
  step: 'step', // *ga specific - Step number for the checkout action
  option: 'option', // *ga specific - Additional info about the checkout action e.g. Visa/Mastercard, FedEx/USPS
  position: 'position', // *ga specific - Position  (string)
  coupon: 'coupon', // *ga specific - Product coupon (string).
  affiliation: 'affiliation', // *ga specific - Affiliation (string).
  revenue: 'revenue', // *ga specific - Revenue (currency).
  tax: 'tax', // *ga specific - Tax (currency).
  shipping: 'shipping' // *ga specific - Shipping (currency).
};

(function () {
  for (var index = 1; index <= 200; index++) {
    channelParams['dimension' + index] = 'dimension' + index;
    channelParams['metric' + index] = 'metric' + index;
  }
})();

var getEventCategory = function getEventCategory(origin) {
  return origin ? 'Enhanced Ecommerce - ' + origin : 'Enhanced Ecommerce';
};

var channelEvents = {
  AddProductImpression: function AddProductImpression(params) {
    var impressions = (params.contents || []).map(function (product) {
      return ['ec:addImpression', (0, _paramsMapper.paramsMapper)(product, channelParams)];
    });
    return [['require', 'ec']].concat(impressions).concat([['send', 'event', getEventCategory(params.origin), 'Product Impressions', {
      nonInteraction: true
    }]]);
  },
  ClickProduct: function ClickProduct(params) {
    var productName = params.name ? params.name : '(not set)';
    var list = params.list ? params.list : '(not set)';
    return [['require', 'ec']].concat([['ec:addProduct', (0, _paramsMapper.paramsMapper)(params, channelParams)]]).concat([['ec:setAction', 'click', { list: list }]]).concat([['send', 'event', getEventCategory(params.origin), 'Product Click', productName]]);
  },
  ViewContent: function ViewContent(params) {
    var productName = params.name ? params.name : '(not set)';
    return [['require', 'ec']].concat([['ec:addImpression', (0, _paramsMapper.paramsMapper)(params, channelParams)]]).concat([['ec:setAction', 'detail']]).concat([['send', 'event', getEventCategory(params.origin), 'View Content', productName, {
      nonInteraction: true
    }]]);
  },
  AddToCart: function AddToCart(params) {
    var productName = params.name ? params.name : '(not set)';
    return [['require', 'ec']].concat([['ec:addProduct', (0, _paramsMapper.paramsMapper)(params, channelParams)]]).concat([['ec:setAction', 'add']]).concat([['send', 'event', getEventCategory(params.origin), 'Add to Cart', productName]]);
  },
  RemoveFromCart: function RemoveFromCart(params) {
    var productName = params.name ? params.name : '(not set)';
    return [['require', 'ec']].concat([['ec:addProduct', (0, _paramsMapper.paramsMapper)(params, channelParams)]]).concat([['ec:setAction', 'remove']]).concat([['send', 'event', getEventCategory(params.origin), 'Remove from Cart', productName]]);
  },
  InitiateCheckout: function InitiateCheckout(params) {
    var products = (params.contents || []).map(function (product) {
      return ['ec:addProduct', (0, _paramsMapper.paramsMapper)(product, channelParams)];
    });
    var requiredParams = (0, _paramsMapper.paramsMapper)({ option: params.option }, channelParams);
    return [['require', 'ec']].concat(products).concat([['ec:setAction', 'checkout', requiredParams]]).concat([['send', 'event', getEventCategory(params.origin), 'Initiate Checkout']]);
  },
  StartPayment: function StartPayment(params) {
    var requiredParams = (0, _paramsMapper.paramsMapper)({ step: 1, option: params.option }, channelParams);
    return [['require', 'ec']].concat([['ec:setAction', 'checkout_option', requiredParams]]).concat([['send', 'event', getEventCategory(params.origin), 'Start Payment']]);
  },
  AddPaymentInfo: function AddPaymentInfo(params) {
    var requiredParams = (0, _paramsMapper.paramsMapper)({ step: 2, option: params.option }, channelParams);
    return [['require', 'ec']].concat([['ec:setAction', 'checkout_option', requiredParams]]).concat([['send', 'event', getEventCategory(params.origin), 'Add Payment Info']]);
  },
  CheckoutStep: function CheckoutStep(params) {
    var requiredParams = (0, _paramsMapper.paramsMapper)({ step: params.step || 3, option: params.option }, channelParams);
    return [['require', 'ec']].concat([['ec:setAction', 'checkout_option', requiredParams]]).concat([['send', 'event', getEventCategory(params.origin), 'Checkout Step ' + requiredParams.step]]);
  },
  Purchase: function Purchase(params) {
    var products = (params.contents || []).map(function (product) {
      return ['ec:addProduct', (0, _paramsMapper.paramsMapper)(product, channelParams)];
    });
    var requiredParams = {};
    ['id', 'affiliation', 'revenue', 'tax', 'shipping', 'coupon'].forEach(function (param) {
      return params[param] && (requiredParams[param] = params[param]);
    });
    return [['require', 'ec']].concat(products).concat([['ec:setAction', 'purchase', (0, _paramsMapper.paramsMapper)(requiredParams, channelParams)]]).concat([['send', 'event', getEventCategory(params.origin), 'Purchase']]);
  },
  Lead: function Lead(_ref) {
    var _ref$category = _ref.category,
        category = _ref$category === undefined ? 'Leads' : _ref$category,
        _ref$action = _ref.action,
        action = _ref$action === undefined ? 'Submitted' : _ref$action,
        _ref$label = _ref.label,
        label = _ref$label === undefined ? 'New Lead' : _ref$label;
    return [['send', 'event', category, action, label]];
  },
  CustomEvent: function CustomEvent(params) {
    var _params$event = params.event,
        event = _params$event === undefined ? 'customEvent' : _params$event,
        eventAction = params.eventAction,
        restOfParams = _objectWithoutProperties(params, ['event', 'eventAction']);

    if (event.toLowerCase() === 'pageview') {
      return [['send', 'pageview', (0, _paramsMapper.paramsMapper)(restOfParams, channelParams)]];
    }
    return [['send', 'event', _extends({
      eventAction: eventAction || event
    }, restOfParams)]];
  }
};
exports.channelEvents = channelEvents;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
 * Adapter for Google Tag Manager
 */
/* eslint-disable camelcase */
var channelEvents = {
  AddProductImpression: function AddProductImpression(_ref) {
    var contents = _ref.contents,
        origin = _ref.origin;

    var impressions = contents;
    return [[[_extends({ event: 'productImpression' }, origin && { origin: origin }, { ecommerce: { impressions: impressions } })]]];
  },
  ClickProduct: function ClickProduct(_ref2) {
    var _ref2$list = _ref2.list,
        list = _ref2$list === undefined ? '(not set)' : _ref2$list,
        origin = _ref2.origin,
        params = _objectWithoutProperties(_ref2, ['list', 'origin']);

    return [[[_extends({ event: 'productClick' }, origin && { origin: origin }, { ecommerce: { click: { actionField: { list: list }, products: [params] } } })]]];
  },
  ViewContent: function ViewContent(_ref3) {
    var _ref3$list = _ref3.list,
        list = _ref3$list === undefined ? '(not set)' : _ref3$list,
        origin = _ref3.origin,
        params = _objectWithoutProperties(_ref3, ['list', 'origin']);

    return [[[_extends({ event: 'viewContent' }, origin && { origin: origin }, { ecommerce: { detail: { actionField: { list: list }, products: [params] } } })]]];
  },
  AddToCart: function AddToCart(_ref4) {
    var origin = _ref4.origin,
        params = _objectWithoutProperties(_ref4, ['origin']);

    return [[[_extends({ event: 'addToCart' }, origin && { origin: origin }, { ecommerce: { add: { products: [params] } } })]]];
  },
  RemoveFromCart: function RemoveFromCart(_ref5) {
    var origin = _ref5.origin,
        params = _objectWithoutProperties(_ref5, ['origin']);

    return [[[_extends({ event: 'removeFromCart' }, origin && { origin: origin }, { ecommerce: { remove: { products: [params] } } })]]];
  },
  InitiateCheckout: function InitiateCheckout(_ref6) {
    var _ref6$contents = _ref6.contents,
        contents = _ref6$contents === undefined ? [] : _ref6$contents,
        origin = _ref6.origin,
        option = _ref6.option;

    var products = [].concat(_toConsumableArray(contents));
    var actionField = Object.assign({}, option && { option: option });
    return [[[_extends({ event: 'checkout' }, origin && { origin: origin }, { ecommerce: { checkout: { actionField: actionField, products: products } } })]]];
  },
  StartPayment: function StartPayment(_ref7) {
    var origin = _ref7.origin;

    var actionField = { step: 1 };
    return [[[_extends({ event: 'checkoutOption' }, origin && { origin: origin }, { ecommerce: { checkout_option: { actionField: actionField } } })]]];
  },
  AddPaymentInfo: function AddPaymentInfo(_ref8) {
    var origin = _ref8.origin,
        option = _ref8.option;

    var actionField = Object.assign({ step: 2 }, option && { option: option });
    return [[[_extends({ event: 'checkoutOption' }, origin && { origin: origin }, { ecommerce: { checkout_option: { actionField: actionField } } })]]];
  },
  CheckoutStep: function CheckoutStep(_ref9) {
    var _ref9$step = _ref9.step,
        step = _ref9$step === undefined ? 3 : _ref9$step,
        origin = _ref9.origin,
        option = _ref9.option;

    var actionField = Object.assign({ step: step }, option && { option: option });
    return [[[_extends({ event: 'checkoutOption' }, origin && { origin: origin }, { ecommerce: { checkout_option: { actionField: actionField } } })]]];
  },
  Purchase: function Purchase(_ref10) {
    var _ref10$contents = _ref10.contents,
        contents = _ref10$contents === undefined ? [] : _ref10$contents,
        origin = _ref10.origin,
        params = _objectWithoutProperties(_ref10, ['contents', 'origin']);

    var products = [].concat(_toConsumableArray(contents));
    var actionField = {};
    ['id', 'affiliation', 'revenue', 'tax', 'shipping', 'coupon'].forEach(function (param) {
      return params[param] && (actionField[param] = params[param]);
    });
    return [[[_extends({ event: 'purchase' }, origin && { origin: origin }, { ecommerce: { purchase: { actionField: actionField, products: products } } })]]];
  },
  Lead: function Lead() {
    return [[[{ event: 'lead' }]]];
  },
  CustomEvent: function CustomEvent(_ref11) {
    var _ref11$event = _ref11.event,
        event = _ref11$event === undefined ? 'customEvent' : _ref11$event,
        params = _objectWithoutProperties(_ref11, ['event']);

    return [[[_extends({ event: event }, params)]]];
  }
};
exports.channelEvents = channelEvents;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelEvents = undefined;

var _biUtils = __webpack_require__(4);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                             * Adapter for Wix Analytics (using BI infrastructure)
                                                                                                                                                                                                                             */

var EventsMap = {
  PageView: { table: 'page_views', paramsMap: {
      pageId: 'page_id',
      pageNumber: 'page_number'
    } },
  AddProductImpression: {},
  ClickProduct: {},
  ViewContent: {},
  AddToCart: {},
  RemoveFromCart: {},
  InitiateCheckout: {},
  AddPaymentInfo: {},
  Purchase: {},
  Lead: {
    name: function name(_ref) {
      var label = _ref.label;
      return (0, _biUtils.removeSpaces)(label);
    },
    table: 'lead_events'
  }
};

function processParams(params) {
  return Object.keys(params).reduce(function (res, key) {
    res[key] = (0, _biUtils.encodeValue)(params[key]);
    return res;
  }, {});
}

// eslint-disable-next-line max-params
function buildParams(type, name) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var table = arguments[4];

  var res = {
    evt: type,
    evn: name,
    data: processParams(params)
  };

  if (options.context && options.context.appDefId) {
    res.appId = options.context.appDefId;
  }

  if (table) {
    res.tbl = table;
  }

  return [[res]];
}

function predefined(name, params, options, table) {
  return buildParams('p', name, params, options, table);
}

function custom(name, params, options, table) {
  return buildParams('c', name, params, options, table);
}

var channelEvents = Object.keys(EventsMap).reduce(function (res, event) {
  var _EventsMap$event = EventsMap[event],
      name = _EventsMap$event.name,
      table = _EventsMap$event.table,
      paramsMap = _EventsMap$event.paramsMap;


  res[event] = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments[1];

    if (typeof name === 'function') {
      name = name(params);
    }

    if (paramsMap) {
      params = Object.keys(paramsMap).reduce(function (pres, pname) {
        pres[paramsMap[pname]] = params[pname];
        return pres;
      }, {});
    }

    name = name || event;

    return predefined(name, params, options, table);
  };

  return res;
}, {
  CustomEvent: function CustomEvent(_ref2, options) {
    var event = _ref2.event,
        targetTable = _ref2.targetTable,
        params = _objectWithoutProperties(_ref2, ['event', 'targetTable']);

    return custom(event, params, options, targetTable);
  }
});
exports.channelEvents = channelEvents;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelEvents = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _biUtils = __webpack_require__(4);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                    * Adapter for BI Analytics (using BI infrastructure)
                                                                                                                                                                                                    * DO NOT add new fields to events before the schema supports them
                                                                                                                                                                                                    */

var SRC = 76;

var Fields = {
  product: ['id', 'sku', 'name', 'category', 'price', 'currency', 'brand', 'variant', 'list', 'position'],
  productList: ['contents'],
  payment: ['option'],
  purchase: ['id', 'affiliation', 'revenue', 'tax', 'shipping', 'coupon', 'contents']
};

var EventsMap = {
  AddProductImpression: { params: { evid: 1100 }, fields: Fields.productList },
  ClickProduct: { params: { evid: 1101 }, fields: Fields.product },
  ViewContent: { params: { evid: 1102 }, fields: Fields.product },
  AddToCart: { params: { evid: 1103 }, fields: [].concat(_toConsumableArray(Fields.product), ['quantity']) },
  RemoveFromCart: { params: { evid: 1104 }, fields: [].concat(_toConsumableArray(Fields.product), ['quantity']) },
  InitiateCheckout: { params: { evid: 1105 }, fields: Fields.productList },
  AddPaymentInfo: { params: { evid: 1106 }, fields: Fields.payment },
  Purchase: { params: { evid: 1107 }, fields: Fields.purchase },
  Lead: { params: { evid: 1108 }, fields: [] }
};

var ParamsMap = {
  price: function price(_price) {
    return { name: 'price', value: (0, _biUtils.encodePrice)(_price) };
  },
  revenue: function revenue(_revenue) {
    return { name: 'revenue', value: (0, _biUtils.encodePrice)(_revenue) };
  },
  tax: function tax(_tax) {
    return { name: 'tax', value: (0, _biUtils.encodePrice)(_tax) };
  },
  shipping: function shipping(_shipping) {
    return { name: 'shipping', value: (0, _biUtils.encodePrice)(_shipping) };
  }
};

function processParams(fields, params) {
  return fields.reduce(function (res, key) {
    var _mapParam = (0, _biUtils.mapParam)(ParamsMap, key, params[key]),
        name = _mapParam.name,
        value = _mapParam.value;

    res[name] = (0, _biUtils.encodeValue)(value);

    return res;
  }, {});
}

var channelEvents = exports.channelEvents = Object.keys(EventsMap).reduce(function (res, event) {
  res[event] = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var res = _extends({
      src: SRC
    }, EventsMap[event].params, processParams(EventsMap[event].fields, params));

    if (options.context && options.context.appDefId) {
      res.appId = options.context.appDefId;
    }

    return [[res]];
  };

  return res;
}, {});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channelEvents = undefined;

var _paramsMapper = __webpack_require__(3);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
 * Adapter for Google GTag
 */
var channelParams = {
  GA_TRACKING_ID: 'GA_TRACKING_ID',
  pagePath: 'page_path',
  pageTitle: 'page_title'
};

(function () {
  for (var index = 1; index <= 200; index++) {
    channelParams['dimension' + index] = 'dimension' + index;
    channelParams['metric' + index] = 'metric' + index;
  }
})();

var channelEvents = {
  PageView: function PageView(_ref, _ref2) {
    var config = _ref2.config;

    var GA_TRACKING_ID = _ref.GA_TRACKING_ID,
        params = _objectWithoutProperties(_ref, ['GA_TRACKING_ID']);

    return [['config', GA_TRACKING_ID || config.trackingId, (0, _paramsMapper.paramsMapper)(params, channelParams)]];
  }
};
exports.channelEvents = channelEvents;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Adapter for VK.com Retargeting
 */

var channelEvents = exports.channelEvents = {
  PageView: function PageView() {
    return [[]];
  }
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.channelNames = exports.api = undefined;

var _analytics = __webpack_require__(6);

var api = _interopRequireWildcard(_analytics);

var _channels = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.api = api;
exports.channelNames = _channels.channelNames;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// analytics-event-adapter.bundle.min.js